module.exports = function() {
  return new Worker(__webpack_public_path__ + "physics.worker.479d9e772e6254cc6bef.js");
};